const { VITE_API_SERVER, VITE_WORKFLOW_SECRET } = import.meta.env;

export const workflowSecretHeaders = (): Record<string, string> =>
  VITE_WORKFLOW_SECRET ? { 'X-Workflow-Secret': VITE_WORKFLOW_SECRET } : {};

export const api_server_url = () => VITE_API_SERVER;
